import React, { useContext, useEffect, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import logo from "../../assets/img/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Row, Col, FormControl } from "react-bootstrap";
import {
    faFileArrowDown,
    faArrowRight,
    faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import jsPDF from "jspdf";
import "jspdf-autotable";
import footerImg from "../../assets/img/QR orden pago.png";
import { getToken } from "../../utils/auth";


const ListaOrdenPago2 = () => {

    const hoy = new Date().toISOString().split("T")[0];
    const [fechaSeleccionada, setFechaSeleccionada] = useState(hoy);

    const [cuitSeleccionado, setCuitSeleccionado] = useState("");
    const [ordenesPago, setOrdenesPago] = useState([]);
    const [ordenesFiltradas, setOrdenesFiltradas] = useState([]);

    const { darkMode } = useContext(DarkModeContext);
    const navigate = useNavigate();

    const itemsPerPage = 20;
    const [currentPage, setCurrentPage] = useState(1);

    const fetchOrdenesPago = async (fecha) => {
        try {
            const token = getToken();

            const body = {
                Token: token,
                FechaPago: fecha.split("-").reverse().join("-"),
            };

            const response = await fetch(process.env.REACT_APP_API_ADMINOPBASE_LISTA, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                setOrdenesPago([]);
                return;
            }

            const data = await response.json();
            setOrdenesPago(data);
            setOrdenesFiltradas(data);

        } catch (error) {
            setOrdenesPago([]);
        }
    };

    useEffect(() => {
        if (fechaSeleccionada) {
            fetchOrdenesPago(fechaSeleccionada);
        }
    }, [fechaSeleccionada]);

    useEffect(() => {
        if (cuitSeleccionado.trim() === "") {
            setOrdenesFiltradas(ordenesPago);
            return;
        }

        const filtradas = ordenesPago.filter(
            (o) =>
                o.cuit.includes(cuitSeleccionado) ||
                o.nombreDocumento
                    ?.toLowerCase()
                    .includes(cuitSeleccionado.toLowerCase())
        );

        setOrdenesFiltradas(filtradas);
    }, [cuitSeleccionado, ordenesPago]);

    const manejarFechaSeleccionada = (e) => {
        const nueva = e.target.value;
        setFechaSeleccionada(nueva);
        setCuitSeleccionado("");
        setCurrentPage(1);
        fetchOrdenesPago(nueva);
    };

    const manejarCuitSeleccionado = (e) => {
        setCuitSeleccionado(e.target.value);
        setCurrentPage(1);
    };

    const descargarOrdenPago = async (documentoId, fechaSeleccionada, nombreComercio, cuit) => {
        const token = getToken();

        // 🔥 Convertir fecha del input (YYYY-MM-DD) → (DD-MM-YYYY)
        const [yyyy, mm, dd] = fechaSeleccionada.split("-");
        const fechaLiqStr = `${dd}-${mm}-${yyyy}`;

        const result = await Swal.fire({
            title: "¿Qué deseas hacer?",
            text: "Selecciona una opción para la descarga del documento.",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Descargar uno",
            cancelButtonText: "Descargar todos",
        });

        const comercioFinal = result.isConfirmed ? nombreComercio : "todos";
        const cuitFinal = cuit; // siempre el cuit real

        try {
            const response = await fetch(process.env.REACT_APP_API_ADMINOPBASE_PDF, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Token: token,
                    Id: documentoId.toString(),
                    FechaPago: fechaLiqStr,       // 👈 FECHA CORRECTA MANDADA AL BACK
                    comercio: comercioFinal,
                    cuit: cuitFinal
                }),
            });

            if (!response.ok) {
                Swal.fire("Error", "No se pudo descargar", "error");
                return;
            }

            const data = await response.json();

            for (const comercio of data.comercios) {
                for (const tipo of comercio.tiposTarjeta) {

                    const doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();

                    const info = comercio.info;
                    const acumulados = tipo.acumulados;
                    const datos = tipo.datos;
                    const sumas = tipo.sumas;

                    // 🔥 FECHA QUE APARECE EN EL PDF (MISMA DEL INPUT)
                    const fechaPDF = fechaLiqStr;

                    // --------------------------------------------
                    // ENCABEZADO
                    // --------------------------------------------
                    const startX = 25;
                    const startY = 25;
                    const alto = 60;
                    const usableWidth = pageWidth - startX * 2;
                    const sectionWidth = usableWidth / 5;

                    doc.setFillColor(255, 255, 255);
                    doc.roundedRect(startX, startY, usableWidth, alto, 10, 10, "F");
                    doc.setDrawColor(220);
                    doc.setLineWidth(0.2);

                    for (let i = 1; i < 5; i++) {
                        const lineX = startX + i * sectionWidth;
                        doc.setDrawColor(230);
                        doc.line(lineX, startY + 8, lineX, startY + alto - 8);
                    }

                    const baseY = startY + 20;
                    doc.addImage(logo, "PNG", startX + 25, baseY, 60, 28);

                    const xOrden = startX + sectionWidth + sectionWidth / 2;
                    const yOrden = startY + alto / 2;
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(8);
                    doc.text("ORDEN DE PAGO", xOrden, yOrden, { align: "center", baseline: "middle" });

                    const xZoco = startX + sectionWidth * 2 + 10;
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(5.5);
                    doc.text("ZOCO - SERVICIOS DE PAGO", xZoco, baseY);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(5);
                    doc.text("CUIT: 30 - 71.679.976 - 6", xZoco, baseY + 7);
                    doc.text("liquidaciones@zocoweb.com.ar", xZoco, baseY + 14);
                    doc.text("www.zocoweb.com.ar", xZoco, baseY + 21);

                    const xCom = startX + sectionWidth * 3 + 10;
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(5.5);
                    doc.text("ESTABLECIMIENTO COMERCIAL", xCom, baseY);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(5);

                    let line = baseY + 7;
                    doc.text(`EMPRESA: ${info.empresa}`, xCom, line);
                    line += 7;
                    doc.text(`DIRECCIÓN: ${info.direccion}`, xCom, line);
                    line += 7;
                    doc.text(`PROVINCIA: ${info.provincia}`, xCom, line);
                    line += 7;
                    doc.text(`TEL: ${info.telefono ?? "-"}`, xCom, line);
                    line += 7;
                    doc.text(`EMAIL: ${info.email ?? "-"}`, xCom, line);

                    const xFecha = startX + sectionWidth * 4 + 10;
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(5.5);
                    doc.text("FECHA", xFecha, baseY);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(5);

                    let yFecha = baseY + 8;

                    // 🔥 FECHA DENTRO DEL PDF
                    doc.text(`LIQUIDACIÓN: ${fechaPDF}`, xFecha, yFecha);
                    yFecha += 7;
                    doc.text(`BANCO: ${info.banco ?? "-"}`, xFecha, yFecha);
                    yFecha += 7;
                    doc.text(`N° CUENTA: ${info.nroCuenta ?? "-"}`, xFecha, yFecha);

                    // --------------------------------------------
                    // SECCION MONTOS
                    // --------------------------------------------
                    const startYMontos = startY + alto + 30;
                    doc.setFillColor(242, 244, 248);
                    doc.roundedRect(45, startYMontos - 8, pageWidth - 90, 22, 10, 10, "F");
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(9);
                    doc.text("MONTO ACUMULADO (MES CORRIENTE)", pageWidth / 2, startYMontos + 8, {
                        align: "center",
                    });

                    const labels = ["HOY SE ACREDITA", "ACUMULADO", "DÉBITO", "CUOTA"];
                    const values = [
                        acumulados.hoySeAcredita,
                        acumulados.acumulado,
                        acumulados.acumuladoDebito,
                        acumulados.acumuladoCredito,
                    ];

                    const boxW = (pageWidth - 150) / 4;
                    const baseX2 = 70;
                    const baseYMontos = startYMontos + 28;

                    labels.forEach((label, i) => {
                        const x = baseX2 + i * boxW;
                        doc.setDrawColor(210);
                        doc.setFillColor(255, 255, 255);
                        doc.roundedRect(x, baseYMontos, boxW - 30, 45, 14, 14, "F");
                        doc.setFont("helvetica", "bold");
                        doc.setFontSize(7);
                        doc.text(label, x + (boxW - 30) / 2, baseYMontos + 12, {
                            align: "center",
                        });
                        doc.setFontSize(9.5);
                        doc.text(`$ ${values[i] || "0,00"}`, x + (boxW - 30) / 2, baseYMontos + 30, {
                            align: "center",
                        });
                    });

                    // --------------------------------------------
                    // TABLA
                    // --------------------------------------------
                    const startYTabla = baseYMontos + 70;
                    const columnas = [
                        "Terminal",
                        "N° Operación",
                        "Fecha OP",
                        "Tarjeta",
                        "Cuotas",
                        "Bruto",
                        "Costo Fin.",
                        "Anticipo",
                        "Arancel",
                        "IVA",
                        "Cost. transc.",
                        "Ret. IIBB",
                        "Ret. Ganancia",
                        "Ret. IVA",
                        "Total OP",
                    ];

                    const filasTabla = datos.map((d) => [
                        d.terminal,
                        d.nroOperacion,
                        d.fechaOperacion,
                        d.tarjeta,
                        d.cuotas,
                        `$${d.bruto}`,
                        `$${d.costoFinanciero}`,
                        `$${d.costoPorAnticipo}`,
                        `$${d.arancel}`,
                        `$${d.ivaArancel}`,
                        `$${d.impDebitoCredito}`,
                        `$${d.retencionIIBB}`,
                        `$${d.retencionGanancia}`,
                        `$${d.retencionIVA}`,
                        `$${d.totalOP}`,
                    ]);

                    doc.autoTable({
                        startY: startYTabla,
                        head: [columnas],
                        body: filasTabla,
                        styles: { fontSize: 6, halign: "center", cellPadding: 1.5 },
                        headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
                        alternateRowStyles: { fillColor: [245, 245, 245] },
                        theme: "striped",
                        margin: { left: 25, right: 25 },
                        tableWidth: pageWidth - 50,
                    });

                    let finalY = doc.lastAutoTable.finalY;
                    if (finalY > pageHeight - 260) {
                        doc.addPage();
                        finalY = 80;
                    }

                    // --------------------------------------------
                    // FOOTER
                    // --------------------------------------------
                    const footerY = finalY + 20;
                    const halfWidth = (pageWidth - 100) / 2;

                    doc.setFillColor(255, 255, 255);
                    doc.roundedRect(30, footerY - 20, pageWidth - 60, 200, 20, 20, "F");

                    const leftX = 50;
                    doc.setFillColor(242, 244, 248);
                    doc.roundedRect(leftX, footerY - 5, halfWidth - 20, 20, 8, 8, "F");
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(9);
                    doc.text("RESUMEN FISCAL", leftX + (halfWidth - 20) / 2, footerY + 8, {
                        align: "center",
                    });

                    const resumenX = leftX + 10;
                    const resumenY = footerY + 25;
                    const resumenW = halfWidth * 0.55;

                    doc.setFillColor(255, 255, 255);
                    doc.roundedRect(resumenX, resumenY, resumenW, 140, 20, 20, "F");

                    doc.setFontSize(8);
                    doc.setFont("helvetica", "bold");
                    doc.text("RESUMEN OPERACIONES", resumenX + 15, resumenY + 15);
                    doc.setFontSize(7);
                    doc.setFont("helvetica", "normal");

                    const resumenData = [
                        ["BRUTO", sumas.bruto],
                        ["Arancel", sumas.arancel],
                        ["IVA 21%", sumas.ivaArancel],
                        ["Cost. transc.", sumas.impDebitoCredito],
                        ["Costo Financiero", sumas.costoFinanciero],
                        ["Costo Anticipo", sumas.costoPorAnticipo],
                        ["RET. IIBB", sumas.retencionIIBB],
                        ["RET. GANANCIAS", sumas.retencionGanancia],
                        ["RET. IVA", sumas.retencionIVA],
                    ];

                    let yResumen = resumenY + 30;
                    resumenData.forEach(([label, value]) => {
                        doc.text(label, resumenX + 15, yResumen);
                        doc.text(`$ ${value}`, resumenX + resumenW - 15, yResumen, {
                            align: "right",
                        });
                        yResumen += 13;
                    });

                    doc.setFont("helvetica", "bold");
                    doc.text("TOTAL OP", resumenX + 15, yResumen + 2);
                    doc.text(`$ ${sumas.totalOP}`, resumenX + resumenW - 15, yResumen + 2, {
                        align: "right",
                    });

                    // --------------------------------------------
                    // QR FINAL
                    // --------------------------------------------
                    const rightX = leftX + halfWidth + 10;
                    const rightW = halfWidth - 20;
                    doc.setFillColor(255, 255, 255);
                    doc.roundedRect(rightX, footerY - 5, rightW, 175, 20, 20, "F");
                    doc.addImage(footerImg, "PNG", rightX + 10, footerY + 5, rightW - 20, 155);

                    // --------------------------------------------
                    // NOMBRE FINAL DEL ARCHIVO
                    // --------------------------------------------
                    const nombreLimpio = comercio.comercio.replace(/[^a-z0-9]/gi, "_");
                    const tipoNombre =
                        tipo.tipoTarjeta === "QR"
                            ? "_QR"
                            : tipo.tipoTarjeta === "NARANJA S"
                                ? "_NARANJA"
                                : "_GENERAL";

                    const nombreArchivo = `OrdenPago_${nombreLimpio}${tipoNombre}_${fechaPDF}.pdf`;
                    doc.save(nombreArchivo);
                }
            }
        } catch (error) { }
    };


    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const current = ordenesFiltradas.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(ordenesFiltradas.length / itemsPerPage);

    return (
        <div className="container mt-4">
            <Row className="my-3 align-items-center">
                <Col className="lg-6">
                    <input
                        type="date"
                        className="form-control"
                        value={fechaSeleccionada}
                        onChange={manejarFechaSeleccionada}
                        style={{
                            textAlign: "center",
                            width: "200px",
                            height: "44px",
                            background: "#B4C400",
                            color: "#FFFFFF",
                            borderRadius: "32px",
                        }}
                    />
                </Col>

                <Col className="lg-6">
                    <FormControl
                        type="text"
                        placeholder="Buscar por CUIT o Nombre"
                        value={cuitSeleccionado}
                        onChange={manejarCuitSeleccionado}
                        style={{
                            width: "200px",
                            height: "44px",
                            borderRadius: "32px",
                        }}
                    />
                </Col>
            </Row>

            {ordenesFiltradas.length > 0 ? (
                <div
                    className={
                        darkMode
                            ? "container table-responsive py-5 bg-tabla-calculadora-dark my-5"
                            : "container table-responsive py-5 bg-tabla-calculadora my-5"
                    }
                >
                    <table className="table table-borderless">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Nombre Documento</th>
                                <th>CUIT</th>
                                <th>Fecha Subida</th>
                                <th>Total Bruto</th>
                                <th>PDF</th>
                            </tr>
                        </thead>

                        <tbody className="text-center">
                            {current.map((orden) => (
                                <tr key={orden.documentoId}>
                                    <td>{orden.documentoId}</td>
                                    <td>{orden.nombreDocumento}</td>
                                    <td>{orden.cuit}</td>
                                    <td>
                                        {orden.fechaPago || (orden.fechaSubida ? new Date(orden.fechaSubida).toLocaleDateString() : "")}
                                    </td>
                                    <td>
                                        ${Number(orden.totalBruto || 0).toLocaleString("es-AR", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </td>

                                    <td>
                                        <Button
                                            style={{
                                                background: "#B4C400",
                                                color: "#FFF",
                                                borderRadius: "32px",
                                            }}
                                            onClick={() =>
                                                descargarOrdenPago(
                                                    orden.documentoId,
                                                    fechaSeleccionada,
                                                    orden.nombreDocumento,
                                                    orden.cuit
                                                )
                                            }
                                        >
                                            <FontAwesomeIcon icon={faFileArrowDown} />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between">
                        <Button
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(currentPage - 1)}
                            style={{
                                background: "#B4C400",
                                color: "#FFF",
                                borderRadius: "32px",
                            }}
                        >
                            <FontAwesomeIcon icon={faArrowLeft} /> Anterior
                        </Button>

                        <span>Página {currentPage} de {totalPages}</span>

                        <Button
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(currentPage + 1)}
                            style={{
                                background: "#B4C400",
                                color: "#FFF",
                                borderRadius: "32px",
                            }}
                        >
                            Siguiente <FontAwesomeIcon icon={faArrowRight} />
                        </Button>
                    </div>
                </div>
            ) : (
                <p className="text-center">No se encontraron órdenes de pago.</p>
            )}
        </div>
    );
};

export default ListaOrdenPago2;
